// Native replacements for the Bluebird-specific promise helpers we still call.
// See issue #10114.

/**
 * Returns a promise that resolves after `ms` milliseconds.
 * Drop-in replacement for Bluebird's `Promise.delay(ms)`.
 *
 * @param {number} ms - How long to wait before the promise resolves.
 * @returns {Promise<void>}
 */
export const promiseDelay = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});

/**
 * Awaits every promise value in `obj` and returns an object of resolved values under the same keys.
 * Drop-in replacement for Bluebird's `Promise.props(obj)`.
 *
 * @param {{[key: string]: unknown}} obj - Object whose values may be promises.
 * @returns {Promise<{[key: string]: unknown}>}
 */
export const props = async(obj) => {
    const entries = Object.entries(obj);
    const values = await Promise.all(entries.map(([, v]) => v));
    return Object.fromEntries(entries.map(([k], i) => [k, values[i]]));
};
